/**
 * better-auth React client.
 *
 * Talks to the Hono-mounted auth routes at `${VITE_API_URL}/api/auth/*`
 * (see apps/api/src/auth.ts). The client exposes:
 *   useSession()        — reactive session state
 *   signIn / signUp     — typed action helpers
 *   signOut             — kills the session cookie
 *
 * Env-driven base URL: in dev `VITE_API_URL=http://localhost:3000`; in
 * prod the canvas sits at maysterko.thinkaheadlab.com and the api at
 * api.maysterko.thinkaheadlab.com (configured via VITE_API_URL).
 */

import { createAuthClient } from 'better-auth/react';

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const authClient = createAuthClient({
  baseURL: `${apiUrl}/api/auth`,
});

export const { useSession, signIn, signUp, signOut } = authClient;
